import React, { useRef, useEffect } from 'react';
import './CompanyShowcase.css';
import { motion } from 'framer-motion';

const CompanyShowcase = () => {
  const logos = [
    'accenture.png',
    'capgemini.png',
    'wipro.png',
    'cognizant.png',
    'infosys.png',
    'tcs.png',
    'deloitte.jpg',
    'genpact.jpg',
    'hcltech.png',
    'hexaware.png',
    'innova.webp',
    'kritikal.jpg',
    'ltimindtree.jpg',
    'devdolphins.png',
    'mu-sigma.png',
    'netcracker.png',
    'citizens-bank.jpg',
    'zf.jpg',
    'nelsis.png'
  ];
const largeLogos = ['genpact', 'netcracker'];
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('fade-up');
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <div ref={sectionRef} className="company-container animate-section">
      <div className="company-bg" />

      <h2 className="company-header-main">Companies That Recognize and Recruit Our Talent</h2>
      <p className="company-subheader">KodeZ Learners Are Powering the Future of Tech</p>

      <div className="logo-grid">
        {logos.map((logo, index) => (
          <motion.img
            key={index}
            src={`/companyLogos/${logo}`}
            alt={`logo-${index}`}
            className={`logo-img ${largeLogos.some(l => logo.toLowerCase().includes(l)) ? 'large-logo' : ''}`}
            whileHover={{ scale: 1.1 }}
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true }}
          />
        ))}
      </div>
    </div>
  );
};

export default CompanyShowcase;